export default "__VITE_ASSET__90ac3cc2__"